import noop from 'utils/noop';

import { PrimaryButton, IconButton, BUTTON_VARIANTS } from 'ui/button';
import { Confirm24, Delete16, Undo16 } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { ToggleType } from './JourneyAssist.constants';
import { StyledHeader, StyledHeaderLeft, StyledHeaderRight } from './JourneyAssistDialog.styled';

export const TOOLBAR_TEST_ID = 'journey-assist-toolbar';
export const KEEP_TEST_ID = 'journey-assist-keep';
export const DELETE_TEST_ID = 'journey-assist-delete';
export const UNDO_REPLACE_TEST_ID = 'journey-assist-undo';

type ToolbarProps = {
  onDelete?: () => void;
  onKeep?: () => void;
  selectedAINodes: number;
  addOrReplace?: string;
};

export const ToolbarHeader = ({
  onDelete = noop,
  onKeep = noop,
  selectedAINodes,
  addOrReplace,
}: ToolbarProps) => {
  return (
    <StyledHeader data-test={TOOLBAR_TEST_ID}>
      <StyledHeaderLeft>
        {selectedAINodes} tile{selectedAINodes === 1 ? '' : 's'} generated
      </StyledHeaderLeft>{' '}
      <StyledHeaderRight>
        {addOrReplace === ToggleType.Replace ? (
          <Tooltip tooltipContent="Revert to original tiles">
            <IconButton
              variant={BUTTON_VARIANTS.SECONDARY}
              onClick={onDelete}
              data-test={UNDO_REPLACE_TEST_ID}
            >
              <Undo16 />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip tooltipContent="Remove tiles">
            <IconButton
              variant={BUTTON_VARIANTS.SECONDARY}
              onClick={onDelete}
              data-test={DELETE_TEST_ID}
            >
              <Delete16 />
            </IconButton>
          </Tooltip>
        )}

        <PrimaryButton onClick={onKeep} data-test={KEEP_TEST_ID}>
          <Confirm24 /> Keep
        </PrimaryButton>
      </StyledHeaderRight>
    </StyledHeader>
  );
};
